import { useLocation, useNavigate } from 'react-router-dom';
import SEO from '../../components/SEO';
import { useLocalization } from '../../hooks/useLocalization';

export default function GovRegisterSuccessPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useLocalization();
  const message = location.state?.message || t('gov.registerSuccess.defaultMessage');

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12">
      <SEO
        title="Registration Submitted"
        description="Your government agency registration has been submitted. Evoltbay will review and notify you upon approval."
        url="https://evoltbay.com/gov/register-success"
        noIndex
      />
      <div className="max-w-md w-full mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
            <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          
          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            {t('gov.registerSuccess.title')}
          </h1>
          
          <p className="text-gray-600 mb-6">
            {message}
          </p>
          
          <div className="bg-blue-50 rounded-md p-4 mb-6">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-blue-800">
                  {t('gov.registerSuccess.whatHappensNext')}
                </h3>
                <div className="mt-2 text-sm text-blue-700">
                  <ul className="list-disc list-inside space-y-1">
                    <li>{t('gov.registerSuccess.step1')}</li>
                    <li>{t('gov.registerSuccess.step2')}</li>
                    <li>{t('gov.registerSuccess.step3')}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          
          <div className="space-y-3">
            <button
              onClick={() => navigate('/login')}
              className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              {t('gov.registerSuccess.goToLogin')}
            </button>
            
            <button
              onClick={() => navigate('/')}
              className="w-full bg-gray-100 text-gray-700 py-2 px-4 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
            >
              {t('gov.registerSuccess.backToHome')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
} 